import './App.css';
import Home from './components/routes/Home.js';
import {Route, Routes} from 'react-router-dom';
import About from './components/routes/About.js';
import Contact from './components/routes/Contact.js';
import Gallery from './components/routes/Gallery.js';

function App() {
  return (
    <div className="App">
      
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/photos" element={<Gallery/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>

      
      
    </div>
  );
}

export default App;
